
// ============================================================================
// CATEGORY INITIAL STATE
// ============================================================================
// ./client/src/context/initialStates/categoryInitialState.js

export default {
  categories: [],
  currentCategory: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
    pages: 0
  }
};
